<template>
  <v-container class="forbidden fill-height pa-0" fluid>
    <v-row class="ma-0" justify="center" align="center">
      <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
        <div class="forbidden__code" aria-label="403">
          <span class="forbidden__digit">4</span>
          <span class="forbidden__digit forbidden__digit--accent">0</span>
          <span class="forbidden__digit">3</span>
        </div>

        <div class="forbidden__rule" aria-hidden="true"></div>

        <h1 class="forbidden__title text-h5 font-weight-medium mb-2">You don't have access to this page</h1>

        <p class="forbidden__subtitle text-body-2 text-medium-emphasis mb-8">
          If you think you should, ask your viaPhoton contact.
        </p>

        <RouterLink :to="{ name: 'Home' }" class="forbidden__link">
          <span class="forbidden__link-text">Go to your start page</span>
          <span class="forbidden__link-arrow" aria-hidden="true">→</span>
        </RouterLink>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { RouterLink } from 'vue-router';

  export default defineComponent({
    name: 'Forbidden',
    components: { RouterLink },
  });
</script>

<style scoped>
  .forbidden {
    --vp-orange: #f88d2a;
    --vp-navy: #2d3e52;
    min-height: calc(100vh - 64px);
  }

  .forbidden__code {
    font-size: clamp(112px, 20vw, 220px);
    line-height: 1;
    font-weight: 200;
    letter-spacing: -0.05em;
  }

  .forbidden__digit {
    color: var(--vp-navy);
  }

  .forbidden__digit--accent {
    color: var(--vp-orange);
    margin: 0 0.02em;
  }

  .forbidden__rule {
    width: 56px;
    height: 3px;
    margin: 28px auto 24px;
    background: var(--vp-orange);
    border-radius: 2px;
  }

  .forbidden__title {
    color: var(--vp-navy);
  }

  .forbidden__link {
    display: inline-flex;
    align-items: baseline;
    gap: 8px;
    color: var(--vp-orange);
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
  }

  .forbidden__link:hover {
    color: var(--vp-navy);
  }
</style>
